(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('CardPrefixConfigController', CardPrefixConfigController);

    CardPrefixConfigController.$inject = ['$state', '$timeout', 'CardPrefixConfig', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CardPrefixConfigController($state, $timeout, CardPrefixConfig, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.allCardPrefixStatus = false;
        vm.cardPrefixes = [];
        vm.filteredCardPrefixes = [];
        vm.cardTypes = ['UZCARD', 'HUMO', 'VISA', 'MASTERCARD', 'UNIONPAY', 'MAESTRO'];
        vm.selectedCardType = '';
        vm.saveCardPrefix = saveCardPrefix;
        vm.saveAllCardPrefixes = saveAllCardPrefixes;
        vm.saveFilteredCardPrefixes = saveFilteredCardPrefixes;
        vm.updateFilteredCardPrefixes = updateFilteredCardPrefixes;

        loadAll();

        function loadAll () {
            vm.cardPrefixes = [];
            vm.allCardPrefixStatus = true;
            CardPrefixConfig.query(function (result) {
                angular.forEach(result, function (res) {
                    var cardPrefix = {
                        id: res.id,
                        prefix: res.prefix,
                        cardType: res.cardType,
                        isActive: res.isActive,
                        lastModifiedDate: res.lastModifiedDate,
                        lastModifiedBy: res.lastModifiedBy
                    };
                    vm.cardPrefixes.push(cardPrefix);
                    if (!res.isActive) {
                        vm.allCardPrefixStatus = false;
                    }
                });
                vm.filteredCardPrefixes = angular.copy(result);
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function saveCardPrefix(cardPrefix) {
            vm.isSaving = true;
            if (cardPrefix.id !== null) {
                CardPrefixConfig.update(cardPrefix, onSuccess, onSaveError);
            } else {
                CardPrefixConfig.save(cardPrefix, onSuccess, onSaveError);
            }
        }

        function onSuccess() {
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function saveAllCardPrefixes() {
            vm.isSaving = true;
            CardPrefixConfig.updateAll(vm.allCardPrefixStatus, onSuccessUpdateStatus, onSaveError);
        }

        function onSuccessUpdateStatus(result) {
            vm.isSaving = false;
            vm.cardPrefixes = result;

            angular.forEach(result, function (cardPrefix) {
                if (cardPrefix.isActive === false) {
                    vm.allCardPrefixStatus = false;
                }
            });
        }

        function saveFilteredCardPrefixes() {
            angular.forEach(vm.filteredCardPrefixes, function(cardPrefixConfig) {
                cardPrefixConfig.isActive = vm.allCardPrefixStatus;
                vm.saveCardPrefix(cardPrefixConfig);
            });
        }

        function updateFilteredCardPrefixes() {
            if (!vm.selectedCardType) {
                vm.filteredCardPrefixes = angular.copy(vm.cardPrefixes);
            } else {
                vm.filteredCardPrefixes = vm.cardPrefixes.filter(function (filteredCardPrefix) {
                    return filteredCardPrefix.cardType === vm.selectedCardType;
                });
            }
            vm.allCardPrefixStatus = vm.filteredCardPrefixes.every(function (filteredCardPrefix) {
                return filteredCardPrefix.isActive === true;
            });
        }
    }
})();
